var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#00954A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2713_5172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6282 10.6153C23.1332 10.1196 22.3293 10.1199 21.8336 10.6153L13.7566 18.6926L10.1667 15.1028C9.671 14.6071 8.86748 14.6071 8.37178 15.1028C7.87607 15.5985 7.87607 16.402 8.37178 16.8977L12.8589 21.3849C13.1066 21.6326 13.4314 21.7567 13.7562 21.7567C14.0811 21.7567 14.4062 21.6329 14.6539 21.3849L23.6282 12.4102C24.1239 11.9148 24.1239 11.111 23.6282 10.6153Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2713_5172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedMark);
export default __webpack_public_path__ + "static/media/checked-mark.daa50971bd24ff5f2094eea52c252753.svg";
export { ForwardRef as ReactComponent };